import { render } from "./AutoScaleUpPolicyTab.vue?vue&type=template&id=4b442b3e&scoped=true"
import script from "./AutoScaleUpPolicyTab.vue?vue&type=script&lang=js"
export * from "./AutoScaleUpPolicyTab.vue?vue&type=script&lang=js"

import "./AutoScaleUpPolicyTab.vue?vue&type=style&index=0&id=4b442b3e&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b442b3e"]])

export default __exports__